﻿
export type Disposable = () => void;

export function ensureDisposed(disposable: Disposable) {
    if (disposable) {
        disposable();
    }
}
